module.exports = __webpack_public_path__ + "static/media/basketball-hoop.3c03c866.svg";